export class TipoPieza {
  idPieza: number;
  descripcion: string;

  constructor(id: number, nombre: string) {
    this.idPieza = id;
    this.descripcion = nombre;
  }
}
